import gql from 'graphql-tag'

const revokeAccess = async (client, resourceType, resourceId, subjectType, subjectId) => {
  const results = await client.mutate({
    mutation: gql`mutation RevokeAccess($input: RevokeAccessInput) {
      RevokeAccess(input: $input)
    }`,
    variables: {input: {resourceType, resourceId, subjectType, subjectId}}
  })
  return results
}

export default revokeAccess;
